import { useTranslation } from "react-i18next";
import { PageDataStats } from "@/components/PageDataStats";
import { useGetCompanyPolicyByIdQuery } from "@/services/(company)/api.company-policies";
import { useParams } from "react-router-dom";
import { ENUM_MS_COMAPNY_POLICIES_STATUS } from "@/utils/enums/company-policies.enum";
import { usePolicyAcknowledgementParams } from "./acknowledgement.params";

export const PolicyStats = () => {
  const { t } = useTranslation("company");
  const { companyPoliciesId } = useParams();
  const { data: singlePolicyData, isLoading } = useGetCompanyPolicyByIdQuery(
    { companyPoliciesId: String(companyPoliciesId) },
    {
      skip: !companyPoliciesId,
      refetchOnMountOrArgChange: true,
    },
  );

  // Reads the same URL the acknowledgement table does — no props needed.
  const tp = usePolicyAcknowledgementParams();
  // Each tile is the status filter it counts; the total is "no filter".
  const statsData = [
    {
      name: t("company:policies_settings.stat_total_assigned"),
      value: singlePolicyData?.data?.stats?.totalAssigned ?? 0,
      icon: "/icons/interface-icons/stats/company-policies/icon-3d-doc-sign-check.png",
      ...tp.statFilter({ statusLabel: "" }),
    },
    {
      name: t("company:policies_settings.stat_acknowledged"),
      value: singlePolicyData?.data?.stats?.acknowledged ?? 0,
      icon: "/icons/interface-icons/stats/shared/icon-3d-green-check.png",
      ...tp.statFilter({
        statusLabel: ENUM_MS_COMAPNY_POLICIES_STATUS.ACKNOWLEDGED,
      }),
    },
    {
      name: t("company:policies_settings.stat_pending"),
      value: singlePolicyData?.data?.stats?.pending ?? 0,
      icon: "/icons/interface-icons/stats/shared/icon-3d-pause.png",
      ...tp.statFilter({
        statusLabel: ENUM_MS_COMAPNY_POLICIES_STATUS.PENDING,
      }),
    },
    {
      name: t("company:policies_settings.stat_overdue"),
      value: singlePolicyData?.data?.stats?.overdue ?? 0,
      icon: "/icons/interface-icons/stats/company-policies/icon-3d-stopwatch.png",
      ...tp.statFilter({
        statusLabel: ENUM_MS_COMAPNY_POLICIES_STATUS.OVERDUE,
      }),
    },
  ];

  return <PageDataStats data={statsData} loading={isLoading} />;
};
